import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full" }
const _hoisted_2 = { class: "flex flex-col justify-between items-start border-b border-gray-lp-400 z-20 relative px-6" }
const _hoisted_3 = { class: "flex flex-row py-2 align-middle items-center justify-between w-full" }
const _hoisted_4 = { class: "text-20px text-black-lp-200 flex flex-row items-center flex-no-wrap relative" }
const _hoisted_5 = { class: "mr-8 font-semibold" }
const _hoisted_6 = { class: "w-full py-2 px-4 h-full bg-gray-lp-1200 flex flex-col gap-y-4 overflow-auto" }
const _hoisted_7 = { class: "flex flex-col gap-4 w-full text-black-lp-100" }
const _hoisted_8 = { class: "text-20px font-semibold" }
const _hoisted_9 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_10 = { class: "flex flex-col gap-4 w-full justify-start items-start" }
const _hoisted_11 = { class: "flex items-center justify-between w-full" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-row px-2 py-1 bg-blue-lp-600 text-blue-lp-700 items-center gap-x-1 rounded-full"
}
const _hoisted_13 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_14 = { class: "text-20px font-semibold" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = { class: "relative pb-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalAddNewToken = _resolveComponent("ModalAddNewToken")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.pageTitle), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Card, {
          class: "p-3",
          rounded: "xl",
          shadow: false
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_7, [
              _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.platformSectionTitle), 1),
              _createVNode("div", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.platformList, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item.value
                  }, [
                    _createVNode(_component_Card, {
                      class: "p-3",
                      rounded: "2xl",
                      shadow: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_10, [
                          _createVNode("div", _hoisted_11, [
                            (item.meta?.icon)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: 
                        require(`@/app/ui/views/integration/assets/${item.meta.icon}.svg`)
                      ,
                                  class: "h-6 w-auto",
                                  alt: "logo"
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            (!item.disabled && item.meta?.totalConnected)
                              ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(item.meta?.totalConnected) + " " + _toDisplayString(_ctx.connectedStoreLabel), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_13, [
                            _createVNode("h1", _hoisted_14, _toDisplayString(item.label), 1),
                            _createVNode("p", _hoisted_15, _toDisplayString(item.key), 1)
                          ]),
                          _createVNode("div", _hoisted_16, [
                            (item.disabled)
                              ? (_openBlock(), _createBlock(_component_LpButton, {
                                  key: 0,
                                  title: _ctx.comingSoonLabel,
                                  outline: "",
                                  disabled: ""
                                }, null, 8, ["title"]))
                              : (item.meta?.totalConnected)
                                ? (_openBlock(), _createBlock(_component_LpButton, {
                                    key: 1,
                                    title: _ctx.addTokenLabel,
                                    outline: "",
                                    color: "red-lp-2400",
                                    textColor: "red-lp-2400",
                                    iconGroupHoverColor: "red-lp-2400",
                                    iconV2: "",
                                    iconLeft: "plus",
                                    "size-icon": "w-5",
                                    onClick: () => _ctx.onAddNewToken(item)
                                  }, null, 8, ["title", "onClick"]))
                                : (_openBlock(), _createBlock(_component_LpButton, {
                                    key: 2,
                                    title: _ctx.connectLabel,
                                    outline: "",
                                    color: "red-lp-2400",
                                    textColor: "red-lp-2400",
                                    iconGroupHoverColor: "red-lp-2400",
                                    iconV2: "",
                                    iconLeft: "plus",
                                    "size-icon": "w-5",
                                    onClick: () => _ctx.onAddNewToken(item)
                                  }, null, 8, ["title", "onClick"]))
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "p-3",
          rounded: "xl",
          shadow: false
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                data: _ctx.listData.data,
                loading: _ctx.listData.loading,
                isEmpty: !_ctx.listData.data?.length && !_ctx.listData.loading,
                iconEmpty: "paper-clip-pencil",
                emptyHeaderMessage: _ctx.emptyHeaderLabel,
                emptyMessage: _ctx.emptyMessageLabel,
                pagination: _ctx.listData.pagination,
                "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listData.pagination = $event)),
                paginationStyle: "v3",
                onRequest: _ctx.fetchList,
                onTryAgain: _ctx.fetchList,
                isDetailAble: false,
                isSpaceTop: false,
                bgHeader: "bg-white border-b border-gray-lp-200",
                paginationV3PaddingVertical: "py-2",
                pinnedSubstractHeight: "400px",
                isPinnedScrollBottom: "",
                customClassPagination: "absolute w-full bottom-4 right-0 left-0 -mb-4 px-4",
                isNoPaddingBottom: "",
                isTabList: false,
                isRightFreeze: "",
                paginationV3ShowingLabel: "Showing",
                paginationV3DataLabel: "entries"
              }, null, 8, ["columns", "data", "loading", "isEmpty", "emptyHeaderMessage", "emptyMessage", "pagination", "onRequest", "onTryAgain"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_ModalAddNewToken, {
      modelValue: _ctx.openModalAddToken,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModalAddToken = $event)),
      platform: _ctx.platformSelected,
      onRefresh: _ctx.onUpdateList
    }, null, 8, ["modelValue", "platform", "onRefresh"]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.notification = $event)),
      isCustom: "",
      message: _ctx.copyStyles.message,
      customStyles: _ctx.copyStyles,
      isAutoDisplay: false,
      isAutoClose: "",
      timeout: 3,
      class: _ctx.copyStyles.width,
      showIconClose: false
    }, null, 8, ["modelValue", "message", "customStyles", "class"])
  ], 64))
}